module.exports = __webpack_public_path__ + "SP_SPT6-Chorese-ef53f645966d460b54cb91168e59fabb.png";